<div class="containers">
  <div class="order-component">
    <!-- Section header: title, search and every list action on one 56px row.
         Replaces the separate action bar that used to sit under the header. -->
    <ui-page-header
      class="orders-header"
      [title]="'quotations_and_orders.order' | translate"
      lucideIcon="ShoppingBag"
      [searchable]="true"
      searchTestId="orders-search"
      [searchControl]="searchInput"
      [searchPlaceholder]="'quotations_and_orders.search_customer_order_or_po' | translate"
      (searchInput)="search($event)"
    >
        <!-- Filter, with its clear badge (see ui-filter-action). -->
        <ui-filter-action
          [active]="hasModuleFilters()"
          (filter)="setFilter()"
          (clear)="clearFilter()"
        ></ui-filter-action>

        <!-- Download -->
        <button
          type="button"
          class="ui-header-action"
          *appHasPermission="{ module: 'order' }"
          [attr.aria-label]="'quotations_and_orders.download' | translate"
          [matTooltip]="'quotations_and_orders.download' | translate"
          matTooltipPosition="below"
          (click)="exportQuotations()"
        >
          <img src="../../../../../assets/icones/download_icon.svg" alt="" />
        </button>

        <!-- Configure columns Button -->
        <!-- FTUE anchor: the "make this table yours" announcement points here. -->
        <ui-table-column-settings
            [appFtueAnchor]="ftueAnchors.ORDERS_COLUMN_SETTINGS"
            triggerIcon="sliders-horizontal"
            [columns]="pickerColumns"
            (columnsChange)="onColumnsChange($event)"
        ></ui-table-column-settings>

        <!-- Inbound order channel -->
        <div
          class="inbound-channel"
          *ngIf="{
            proc: (processingCount$ | async)?.processing ?? 0,
            err: (processingCount$ | async)?.needs_review ?? 0,
            total: ((processingCount$ | async)?.processing ?? 0) + ((processingCount$ | async)?.needs_review ?? 0),
            active: ((processingCount$ | async)?.processing ?? 0) + ((processingCount$ | async)?.needs_review ?? 0) > 0,
            visible: (showProcessing$ | async) ?? true
          } as ic"
          (mouseenter)="loadInboundChannel()"
        >
          <button
            type="button"
            class="inbound-channel__btn"
            [ngClass]="{
              'inbound-channel__btn--tinted': ic.active && ic.visible,
              'inbound-channel__btn--error': ic.err > 0
            }"
            [attr.aria-label]="
              (ic.active
                ? ic.visible
                  ? 'orders.inbound_channel.aria_hide'
                  : 'orders.inbound_channel.aria_show'
                : 'orders.inbound_channel.aria_copy'
              ) | translate
            "
            [attr.aria-pressed]="ic.active ? !ic.visible : null"
            (click)="onInboundChannelClick(ic.active)"
          >
            <ui-svg-icon svgIcon="at-sign" size="small"></ui-svg-icon>
            <span *ngIf="ic.active && ic.visible" class="volta-pulse inbound-channel__dot" [class.inbound-channel__dot--error]="ic.err > 0"></span>
            <span *ngIf="ic.active && !ic.visible" class="inbound-channel__badge" [class.inbound-channel__badge--error]="ic.err > 0">{{
              ic.total
            }}</span>
          </button>

          <div class="inbound-channel__menu">
            <div class="inbound-channel__popover">
              <!-- header -->
              <div class="inbound-channel__header">
                <ui-svg-icon svgIcon="at-sign" size="xsmall"></ui-svg-icon>
                <span class="inbound-channel__title">{{ "orders.inbound_channel.title" | translate }}</span>
                <span class="inbound-channel__live" *ngIf="ic.active">
                  <span class="volta-pulse inbound-channel__live-dot"></span>
                  {{ "orders.inbound_channel.live" | translate }}
                </span>
              </div>

              <!-- live breakdown -->
              <ng-container *ngIf="ic.active; else inboundIdleBlock">
                <div class="inbound-channel__section">
                  <div class="inbound-channel__line">
                    <span class="volta-pulse inbound-channel__line-dot"></span>
                    <div>
                      <div class="inbound-channel__line-title">
                        {{
                          (ic.proc === 1 ? "orders.inbound_channel.analyzing" : "orders.inbound_channel.analyzing_plural")
                            | translate: { count: ic.proc }
                        }}
                      </div>
                      <div class="inbound-channel__line-detail">
                        {{ "orders.inbound_channel.analyzing_detail" | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="inbound-channel__line" *ngIf="ic.err > 0">
                    <span class="inbound-channel__line-icon inbound-channel__line-icon--error">
                      <ui-svg-icon svgIcon="alert-circle-red" size="xsmall"></ui-svg-icon>
                    </span>
                    <div>
                      <div class="inbound-channel__line-title inbound-channel__line-title--error">
                        {{ "orders.inbound_channel.couldnt_process_count" | translate: { count: ic.err } }}
                      </div>
                      <div class="inbound-channel__line-detail">
                        {{ "orders.inbound_channel.couldnt_process_detail" | translate }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- visibility toggle -->
                <button type="button" class="inbound-channel__toggle" (click)="toggleProcessingVisibility()">
                  <span class="inbound-channel__toggle-label">
                    {{
                      (ic.visible ? "orders.inbound_channel.pinned_to_top" : "orders.inbound_channel.hidden_from_list")
                        | translate: { count: ic.total }
                    }}
                  </span>
                  <span class="inbound-channel__toggle-action">
                    {{ (ic.visible ? "orders.inbound_channel.click_to_hide" : "orders.inbound_channel.click_to_show") | translate }}
                  </span>
                </button>

                <!-- address footer -->
                <div class="inbound-channel__footer">
                  <span class="inbound-channel__footer-text">
                    {{ "orders.inbound_channel.via_address" | translate: { address: inboundChannel?.address || "" } }}
                  </span>
                  <button
                    type="button"
                    class="inbound-channel__copy-icon"
                    [class.inbound-channel__copy-icon--copied]="channelCopied"
                    [attr.aria-label]="'orders.inbound_channel.aria_copy' | translate"
                    (click)="copyInboundAddress()"
                  >
                    {{ (channelCopied ? "orders.inbound_channel.copied" : "orders.inbound_channel.copy") | translate }}
                  </button>
                </div>
              </ng-container>

              <!-- idle -->
              <ng-template #inboundIdleBlock>
                <div class="inbound-channel__section">
                  <div class="inbound-channel__description">
                    {{ "orders.inbound_channel.description" | translate }}
                  </div>
                  <div class="inbound-channel__address-group">
                    <div class="inbound-channel__address-label">
                      {{ "orders.inbound_channel.forwarding_address" | translate }}
                    </div>
                    <div class="inbound-channel__address-field">
                      <span class="inbound-channel__address">{{ inboundChannel?.address }}</span>
                      <button
                        type="button"
                        class="inbound-channel__copy"
                        [class.inbound-channel__copy--copied]="channelCopied"
                        [attr.aria-label]="'orders.inbound_channel.aria_copy' | translate"
                        (click)="copyInboundAddress()"
                      >
                        {{ (channelCopied ? "orders.inbound_channel.copied" : "orders.inbound_channel.copy") | translate }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="inbound-channel__received">
                  {{ "orders.inbound_channel.received_last_7_days" | translate: { count: inboundChannel?.last7_count ?? 0 } }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="action-buttons-group" *ngIf="!(isCopilot$ | async)">
          <!-- Bulk actions for the current selection live in the floating
               ui-bulk-actions-bar at the bottom of the table, not here. -->
          <!-- New Order Button -->
          <ui-button
            *appHasPermission="{ module: 'order', action: 'create' }"
            type="primary"
            icon="plus-cc"
            [label]="'quotations_and_orders.new_order' | translate"
            testId="new-order-btn"
            (click)="addQuotation()"
          ></ui-button>
        </div>
    </ui-page-header>

    <!-- Quick filter by Status Section -->
    <div class="quick-filter" *ngIf="status_count$ | async as status_count">
      <span class="quick-filter-label">{{ "quotations_and_orders.quick_filter_by_status" | translate }}</span>

      <div class="status-pills">
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('all')" (click)="getQuotationsStatus('all')">
          <span>{{ "common.all" | translate }}</span>
          <span class="status-count"> {{ status_count.all }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('draft')" (click)="getQuotationsStatus('draft')">
          <span>{{ "common.draft" | translate }}</span>
          <span class="status-count"> {{ status_count.draft || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('to_be_validated')" (click)="getQuotationsStatus('to_be_validated')">
          <span>{{ "common.to_be_validated" | translate }}</span>
          <span class="status-count blue"> {{ status_count.to_be_validated || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('requested')" (click)="getQuotationsStatus('requested')">
          <span>{{ "quotations_and_orders.quotations_request" | translate }}</span>
          <span class="status-count blue"> {{ status_count.requested || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('sent')" (click)="getQuotationsStatus('sent')">
          <span>{{ "quotations_and_orders.QuotationStatus.sent" | translate }}</span>
          <span class="status-count blue"> {{ status_count.sent || 0 }}</span>
        </button>
        <button
          class="status-pill outline"
          [ngStyle]="getStatusSelectedStyle('pending_inventory')"
          (click)="getQuotationsStatus('pending_inventory')"
        >
          <span>{{ "common.pending_inventory" | translate }}</span>
          <span class="status-count orange"> {{ status_count.pending_inventory || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('cancel')" (click)="getQuotationsStatus('cancel')">
          <span>{{ "common.cancelled" | translate }}</span>
          <span class="status-count red"> {{ status_count.cancel || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('declined')" (click)="getQuotationsStatus('declined')">
          <span>{{ "common.rejected" | translate }}</span>
          <span class="status-count red"> {{ status_count.declined || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('sale')" (click)="getQuotationsStatus('sale')">
          <span>{{ "quotations_and_orders.list_quotations.order_completed" | translate }}</span>
          <span class="status-count green"> {{ status_count.sale || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('done')" (click)="getQuotationsStatus('done')">
          <span>{{ "common.sent_to_erp" | translate }}</span>
          <span class="status-count green"> {{ status_count.done || 0 }}</span>
        </button>
        <button class="status-pill outline" [ngStyle]="getStatusSelectedStyle('archived')" (click)="getQuotationsStatus('archived')">
          <span>{{ "quotations_and_orders.list_quotations.archived" | translate }}</span>
          <span class="status-count"> {{ status_count.archived || 0 }}</span>
        </button>
      </div>
    </div>

    <!-- Orders List Table -->
    <div
      class="order-list-container"
      [class.order-list-container--with-bulk-bar]="selectedQuotations.length > 0"
      *ngIf="(displayQuotations$ | async)!.length > 0"
    >
      <div class="table-wrapper" #tableWrapper>
        <table class="orders-table">
          <thead>
            <tr class="order-header-row">
              <th class="th-select" (click)="$event.stopPropagation()">
                <ui-checkbox
                  [checked]="isAllSelected"
                  [indeterminate]="isPartialSelected"
                  [ariaLabel]="'common.select_all' | translate"
                  (changed)="toggleAll($event.checked)"
                ></ui-checkbox>
              </th>
              <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                <th *ngSwitchCase="'customer'" class="th-customer">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.customer" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'company_name' && activeSortMode == 'asc'"
                        (click)="sortBy('company_name', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'company_name' && activeSortMode == 'desc'"
                        (click)="sortBy('company_name', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'location'" class="th-location">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.location" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'location_name' && activeSortMode == 'asc'"
                        (click)="sortBy('location_name', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'location_name' && activeSortMode == 'desc'"
                        (click)="sortBy('location_name', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'source'" class="th-source">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.source" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'channel' && activeSortMode == 'asc'"
                        (click)="sortBy('channel', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'channel' && activeSortMode == 'desc'"
                        (click)="sortBy('channel', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'volta_id'" class="th-volta-id">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.volta_id" | translate }}</span>
                    <div class="sort-arrows">
                      <span class="arrow-up" [class.active]="activeSortBy == 'name' && activeSortMode == 'asc'" (click)="sortBy('name', 'asc')"></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'name' && activeSortMode == 'desc'"
                        (click)="sortBy('name', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'erp_id'" class="th-erp-id">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.list_quotations.erp_id" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'external_id' && activeSortMode == 'asc'"
                        (click)="sortBy('external_id', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'external_id' && activeSortMode == 'desc'"
                        (click)="sortBy('external_id', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'buyer_po'" class="th-buyer-po">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "companies.customer_po_number" | translate }}</span>
                  </div>
                </th>
                <th *ngSwitchCase="'quote_id'" class="th-quote-id">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.quote_id" | translate }}</span>
                  </div>
                </th>
                <th *ngSwitchCase="'catalog'" class="th-catalog">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "Catalogs.catalog_name" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'pricelist_name' && activeSortMode == 'asc'"
                        (click)="sortBy('pricelist_name', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'pricelist_name' && activeSortMode == 'desc'"
                        (click)="sortBy('pricelist_name', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'order_creator'" class="th-order-creator people-col">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.order_creator_col" | translate }}</span>
                  </div>
                </th>
                <th *ngSwitchCase="'order_owner'" class="th-order-owner people-col">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.order_owner_col" | translate }}</span>
                  </div>
                </th>
                <th *ngSwitchCase="'skus'" class="th-skus">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.skus" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'nbr_products' && activeSortMode == 'asc'"
                        (click)="sortBy('nbr_products', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'nbr_products' && activeSortMode == 'desc'"
                        (click)="sortBy('nbr_products', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'order_amount'" class="th-amount">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.order_amount" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'amount_total' && activeSortMode == 'asc'"
                        (click)="sortBy('amount_total', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'amount_total' && activeSortMode == 'desc'"
                        (click)="sortBy('amount_total', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'margin'" class="th-margin">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.margin" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'estimated_margin' && activeSortMode == 'asc'"
                        (click)="sortBy('estimated_margin', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'estimated_margin' && activeSortMode == 'desc'"
                        (click)="sortBy('estimated_margin', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'status'" class="th-status">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "common.status" | translate }}</span>
                  </div>
                </th>
                <th *ngSwitchCase="'created'" class="th-created">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.list_quotations.created" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'date_order' && activeSortMode == 'asc'"
                        (click)="sortBy('date_order', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'date_order' && activeSortMode == 'desc'"
                        (click)="sortBy('date_order', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
                <th *ngSwitchCase="'last_update'" class="th-last-update">
                  <div class="header-title-with-sort">
                    <span class="header-title">{{ "quotations_and_orders.last_update" | translate }}</span>
                    <div class="sort-arrows">
                      <span
                        class="arrow-up"
                        [class.active]="activeSortBy == 'latest_event_date' && activeSortMode == 'asc'"
                        (click)="sortBy('latest_event_date', 'asc')"
                      ></span>
                      <span
                        class="arrow-down"
                        [class.active]="activeSortBy == 'latest_event_date' && activeSortMode == 'desc'"
                        (click)="sortBy('latest_event_date', 'desc')"
                      ></span>
                    </div>
                  </div>
                </th>
              </ng-container>
              <th class="th-copilot" *ngIf="isCopilot$ | async">
                <div class="header-title-with-sort score-copilot-header">
                  {{ "quotations_and_orders.copilot_score.copilot_score" | translate }}
                  <div class="sort-arrows">
                    <span
                      class="arrow-up"
                      [class.active]="activeSortBy == 'final_score' && activeSortMode == 'asc'"
                      (click)="sortBy('final_score', 'asc')"
                    ></span>
                    <span
                      class="arrow-down"
                      [class.active]="activeSortBy == 'final_score' && activeSortMode == 'desc'"
                      (click)="sortBy('final_score', 'desc')"
                    ></span>
                  </div>
                </div>
              </th>
              <th class="th-actions"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let quote of displayQuotations$ | async; let i = index">
              <tr *ngIf="quote.ato_processing_status === 'processing'" class="order-row order-row--processing">
                <td class="td-select ato-row__mark">
                  <span class="volta-pulse ato-row__sparkle">
                    <app-svg-icon svgIcon="sparkle"></app-svg-icon>
                  </span>
                </td>
                <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                <td *ngSwitchCase="'customer'" class="ato-sender-cell">
                  <div class="ato-sender">
                    <span class="ato-sender__avatar">
                      <app-svg-icon svgIcon="activity-mail"></app-svg-icon>
                    </span>
                    <span class="ato-sender__text">
                      <span class="ato-sender__email">{{ quote.ato_sender_email }}</span>
                      <span class="ato-sender__subject">{{ quote.ato_email_subject }}</span>
                    </span>
                  </div>
                </td>
                <td *ngSwitchCase="'location'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'source'" class="ato-skel-cell">
                  <span class="ato-chip">
                    <app-svg-icon class="ato-chip__icon" svgIcon="activity-mail"></app-svg-icon>
                    {{ "quotations_and_orders.email" | translate }}
                  </span>
                </td>
                <td *ngSwitchCase="'volta_id'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'erp_id'" class="ato-skel-cell"><span class="volta-skel ato-skel--sm"></span></td>
                <td *ngSwitchCase="'buyer_po'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'quote_id'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'catalog'" class="ato-skel-cell"><span class="volta-skel ato-skel--lg"></span></td>
                <td *ngSwitchCase="'order_creator'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'order_owner'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'skus'" class="ato-skel-cell ato-skel-cell--right"><span class="volta-skel ato-skel--sm"></span></td>
                <td *ngSwitchCase="'order_amount'" class="ato-skel-cell ato-skel-cell--right">
                  <span class="volta-skel ato-skel--md"></span>
                </td>
                <td *ngSwitchCase="'margin'" class="ato-skel-cell ato-skel-cell--right"><span class="volta-skel ato-skel--sm"></span></td>
                <td *ngSwitchCase="'status'" class="ato-pill-cell">
                  <span class="ato-pill ato-pill--processing">
                    <span class="volta-pulse ato-pill__dot"></span>
                    <span>{{ "orders.processing.label" | translate }}</span>
                    <span class="ato-pill__elapsed">· {{ elapsedFor(quote.processing_started_at) }}</span>
                  </span>
                </td>
                <td *ngSwitchCase="'created'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                <td *ngSwitchCase="'last_update'" class="ato-skel-cell"><span class="volta-skel ato-skel--md"></span></td>
                </ng-container>
                <td *ngIf="isCopilot$ | async" class="ato-skel-cell"><span class="volta-skel ato-skel--sm"></span></td>
                <td class="td-actions"></td>
              </tr>

              <tr *ngIf="quote.ato_processing_status === 'needs_review'" class="order-row order-row--error">
                <td class="td-select" (click)="$event.stopPropagation()">
                  <ui-checkbox
                    [checked]="isQuoteSelected(quote)"
                    [ariaLabel]="'common.select' | translate"
                    (changed)="toggleOne(quote, $event.checked, $event)"
                  ></ui-checkbox>
                </td>
                <td *ngIf="isColumnVisible('customer')" class="ato-sender-cell">
                  <div class="ato-sender">
                    <span class="ato-sender__avatar ato-sender__avatar--error">
                      <app-svg-icon svgIcon="alert-circle-red"></app-svg-icon>
                    </span>
                    <span class="ato-sender__text">
                      <span class="ato-sender__email">{{ quote.ato_sender_email }}</span>
                      <span class="ato-sender__subject">{{ quote.ato_email_subject }}</span>
                    </span>
                  </div>
                </td>
                <td class="ato-error-cell" [attr.colspan]="100">
                  <div class="ato-error">
                    <span
                      class="ato-error__reason"
                      tooltip=""
                      [tooltipTemplate]="reasonTooltip"
                      [center]="true"
                      [maxWidth]="'320px'"
                      (click)="$event.stopPropagation()"
                    >
                      <span class="ato-pill ato-pill--error">
                        {{ quote | reviewReason: "label" | translate }}
                      </span>
                      <app-svg-icon class="ato-error__info" svgIcon="info"></app-svg-icon>
                    </span>
                    <ng-template #reasonTooltip>
                      <div class="ato-error-tooltip">
                        <span class="ato-error-tooltip__title">{{ quote | reviewReason: "label" | translate }}</span>
                        <span class="ato-error-tooltip__text">{{ quote | reviewReason: "detail" | translate }}</span>
                      </div>
                    </ng-template>
                    <span class="ato-error__spacer"></span>
                    <div class="ato-error__actions">
                      <button type="button" class="ato-btn ato-btn--create" (click)="createManually(quote); $event.stopPropagation()">
                        <app-svg-icon svgIcon="plus"></app-svg-icon>
                        {{ "orders.processing.create_manually" | translate }}
                      </button>
                      <button type="button" class="ato-btn ato-btn--delete" (click)="deleteProcessingRow(quote); $event.stopPropagation()">
                        <app-svg-icon svgIcon="Trash"></app-svg-icon>
                        {{ "orders.processing.delete" | translate }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                *ngIf="quote.ato_processing_status !== 'processing' && quote.ato_processing_status !== 'needs_review'"
                class="order-row"
                [class.order-row--unread]="quote.is_read === false"
                [attr.data-row-id]="quote.id"
                (click)="details(quote.id)"
              >
                <td class="td-select" (click)="$event.stopPropagation()">
                  <ui-checkbox
                    [checked]="isQuoteSelected(quote)"
                    [ariaLabel]="'common.select' | translate"
                    (changed)="toggleOne(quote, $event.checked, $event)"
                  ></ui-checkbox>
                </td>
                <ng-container *ngFor="let key of orderedColumns" [ngSwitch]="key">
                <td *ngSwitchCase="'customer'" class="td-customer">
                  <div class="customer-name" *ngIf="quote.company_name; else noCustomerName">
                    {{ quote.company_name }}
                  </div>
                  <ng-template #noCustomerName>
                    <div class="customer-name">N/A</div>
                  </ng-template>
                </td>
                <td *ngSwitchCase="'location'" class="td-location">
                  <div class="cell-main" *ngIf="quote.location_name && quote.location_name !== 'N/A'; else noLocation">
                    {{ quote.location_name }}
                  </div>
                  <ng-template #noLocation>
                    <div class="cell-main">N/A</div>
                  </ng-template>
                  <div class="cell-sub" [matTooltip]="quote.location_address" *ngIf="quote.location_address">{{ quote.location_address }}</div>
                </td>
                <td *ngSwitchCase="'source'" class="td-source">
                  <div class="source-badge" [class]="quote.channel == 'BO portal' || quote.channel == 'prompt' ? 'backoffice' : 'email'">
                    <div class="source-icon">
                      <img *ngIf="quote.channel == 'BO portal' || quote.channel == 'prompt'" src="assets/icones/volta_small_icon_tr.svg" alt="" />
                      <img *ngIf="quote.channel == 'email'" src="assets/icones/email_icon.svg" alt="" />
                      <img *ngIf="quote.channel == 'B2B portal' || quote.channel == 'Agent portal'" src="assets/icones/volta_smal_icon.svg" alt="" />
                    </div>
                    <span *ngIf="quote.channel == 'BO portal' || quote.channel == 'prompt'">{{
                      "quotations_and_orders.backoffice" | translate
                    }}</span>
                    <span *ngIf="quote.channel == 'email'">{{ "quotations_and_orders.email" | translate }}</span>
                    <span *ngIf="quote.channel == 'B2B portal'">{{ "quotations_and_orders.b2b_portal" | translate }}</span>
                    <span *ngIf="quote.channel == 'Agent portal'">{{ "quotations_and_orders.agent_portal" | translate }}</span>
                  </div>
                </td>
                <td *ngSwitchCase="'volta_id'" class="td-volta-id">
                  <ui-copyable class="cell-main" [value]="quote.name" [label]="'quotations_and_orders.volta_id' | translate">
                    {{ quote.name }}
                  </ui-copyable>
                  <app-duplicate-badge
                    *ngIf="quote.duplicate_info?.has_duplicates"
                    [duplicateInfo]="quote.duplicate_info!"
                    (dismissed)="dismissDuplicateBadge(quote)"
                    (click)="$event.stopPropagation()">
                  </app-duplicate-badge>
                </td>
                <td *ngSwitchCase="'erp_id'" class="td-erp-id">
                  <ui-copyable class="cell-main" [value]="quote.external_id" [label]="'quotations_and_orders.list_quotations.erp_id' | translate">
                    {{ quote.external_id || "—" }}
                  </ui-copyable>
                </td>
                <td *ngSwitchCase="'buyer_po'" class="td-buyer-po">
                  <ui-copyable class="cell-main" [value]="quote.buyer_po" [label]="'companies.customer_po_number' | translate">
                    {{ quote.buyer_po || "—" }}
                  </ui-copyable>
                </td>
                <td *ngSwitchCase="'quote_id'" class="td-quote-id">
                  <div class="cell-main">{{ quote.quote_id || "—" }}</div>
                </td>
                <td *ngSwitchCase="'catalog'" class="td-catalog">
                  <div class="catalog-name">{{ quote.pricelist_name }}</div>
                </td>
                <td *ngSwitchCase="'order_creator'" class="td-order-creator td-people" (click)="$event.stopPropagation()">
                  <span class="list-user-chip" *ngIf="quote.order_creator as c">
                    <span class="list-user-avatar" [style.background]="getUserColor(c)">{{ userInitials(c.name) }}</span>
                    <span class="list-user-text">{{ c.name }}</span>
                  </span>
                  <span *ngIf="!quote.order_creator" class="list-user-empty">—</span>
                </td>
                <td *ngSwitchCase="'order_owner'" class="td-order-owner td-people" (click)="$event.stopPropagation()">
                  <button type="button" class="owner-edit-trigger"
                    #ownerTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="ownerPopover.menu"
                    (menuOpened)="ownerPopover.onOpen()">
                    <span class="list-user-chip list-user-chip-owner" *ngIf="quote.owner as o">
                      <span class="list-user-avatar" [style.background]="getUserColor(o)">{{ userInitials(o.name) }}</span>
                      <span class="list-user-text">{{ o.name }}</span>
                    </span>
                    <span *ngIf="!quote.owner" class="list-user-empty">—</span>
                    <ui-svg-icon class="owner-inline-edit-icon" svgIcon="inline-edit" size="medium"></ui-svg-icon>
                  </button>
                  <app-order-owner-popover #ownerPopover [order]="quote"
                    (ownerChanged)="onOwnerChanged(quote, $event); ownerTrigger.closeMenu()"></app-order-owner-popover>
                </td>
                <td *ngSwitchCase="'skus'" class="td-skus">
                  <div class="sku-count">{{ quote.nbr_products }}</div>
                </td>
                <td *ngSwitchCase="'order_amount'" class="td-amount">
                  <div class="amount amount--masked" *ngIf="isPricingMaskedForRow(quote, 'order_amount'); else amountValue"
                    [matTooltip]="'quotations_and_orders.pricing_hidden_for_order' | translate">—</div>
                  <ng-template #amountValue>
                    <div class="amount">{{ quote.amount_total | number: "1.2-2" }} {{ quote.currency?.symbol }}</div>
                  </ng-template>
                </td>
                <td *ngSwitchCase="'margin'" class="td-margin">
                  <div class="margin margin--masked" *ngIf="isPricingMaskedForRow(quote, 'margin'); else marginValue"
                    [matTooltip]="'quotations_and_orders.pricing_hidden_for_order' | translate">—</div>
                  <ng-template #marginValue>
                    <div class="margin">{{ quote.estimated_margin | number: "1.2-2" }} {{ quote.currency?.symbol }}</div>
                    <div class="cell-sub" *ngIf="quote.amount_total">
                      {{ ((quote.estimated_margin ?? 0) / quote.amount_total) * 100 | number: "1.1-1" }}%
                    </div>
                  </ng-template>
                </td>
                <td *ngSwitchCase="'status'" class="td-status">
                  <div class="status-badge" [ngStyle]="getStatusStyles(quote.status)">{{ getStatusTranslation(quote.status) }}</div>
                </td>
                <td *ngSwitchCase="'created'" class="td-created">
                  <div class="update-date">{{ quote.date_order | adaptToUserUtcOffset | date: DATE_FORMAT }}</div>
                </td>
                <td *ngSwitchCase="'last_update'" class="td-last-update">
                  <div class="update-date">{{ quote.latest_event_date | adaptToUserUtcOffset | date: DATE_FORMAT }}</div>
                  <div class="archived-date" *ngIf="quote.archived_at">{{ 'quotations_and_orders.list_quotations.archived_on' | translate }}: {{ quote.archived_at | adaptToUserUtcOffset | date: DATE_FORMAT }}</div>
                </td>
                </ng-container>
                <td class="td-copilot" *ngIf="isCopilot$ | async" (click)="$event.stopPropagation()">
                  <div class="score-copilot">
                    <div class="bar-div">
                      <mat-progress-bar class="example-margin" [value]="quote.final_score"></mat-progress-bar>
                      <span class="blue">{{ quote.final_score | number: "1.2-2" }} <span class="order-id">/ 100</span></span>
                    </div>
                    <div class="hint" (click)="viewOrdersScore(quote)">
                      <img class="hint_icon" src="assets/icones/hint.svg" alt="" />
                    </div>
                  </div>
                </td>
                <td class="td-actions" (click)="$event.stopPropagation()">
                  <button
                    *ngIf="canShowRowActions$ | async"
                    class="row-actions-trigger"
                    mat-icon-button
                    [matMenuTriggerFor]="rowMenu"
                    [attr.aria-label]="'quotations_and_orders.actions.title' | translate"
                  >
                    <mat-icon style="color: #9d9a9a">more_vert</mat-icon>
                  </button>
                  <mat-menu #rowMenu="matMenu" class="orders-row-menu">
                    <button
                      mat-menu-item
                      class="menu_item"
                      *appHasPermission="{ module: 'order', action: 'edit' }"
                      (click)="duplicateQuotation(quote, $event)"
                    >
                      <img src="assets/icones/copy.svg" alt="" onerror="this.style.display = 'none'" />
                      <span>{{ "quotations_and_orders.actions.duplicate" | translate }}</span>
                    </button>
                    <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
                      <button mat-menu-item class="menu_item" *ngIf="canArchive(quote)" (click)="archiveQuotation(quote, $event)">
                        <img src="assets/icones/archive.svg" alt="" onerror="this.style.display = 'none'" />
                        <span>{{ "quotations_and_orders.actions.archive" | translate }}</span>
                      </button>
                      <button mat-menu-item class="menu_item" *ngIf="canUnarchive(quote)" (click)="unarchiveQuotation(quote, $event)">
                        <img src="assets/icones/unarchive.svg" alt="" onerror="this.style.display = 'none'" />
                        <span>{{ "quotations_and_orders.actions.unarchive" | translate }}</span>
                      </button>
                    </ng-container>
                    <ng-container *appHasPermission="{ module: 'order', action: 'delete' }">
                      <button mat-menu-item class="menu_item menu_item--danger" *ngIf="canDelete(quote)" (click)="deleteQuotationFromList(quote, $event)">
                        <img src="assets/icones/cancel_icon.svg" alt="" />
                        <span>{{ "quotations_and_orders.actions.delete" | translate }}</span>
                      </button>
                    </ng-container>
                  </mat-menu>
                </td>
              </tr>
              <!-- Kill stock alert row -->
              <tr class="alert-row" *ngIf="quote.score && quote.score.kill_stock.length > 0 && (isCopilot$ | async)">
                <td [attr.colspan]="100">
                  <div class="alert-block">
                    <div class="alert_div">
                      <img src="assets/icones/kill_stock_icon.svg" alt="alert-icon" />
                      <span class="error-message">
                        {{ "quotations_and_orders.list_quotations.stock_shortage_message" | translate }}
                      </span>
                      <span (click)="viewKillStock(quote)" class="view-orders">{{
                        "quotations_and_orders.list_quotations.view_orders" | translate
                      }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- ─────────────────────────────────────────────────────────────────── -->
      <!-- Bulk actions for the current selection. Floats centred at the       -->
      <!-- bottom of the table so selecting rows never reflows the action bar. -->
      <!-- ─────────────────────────────────────────────────────────────────── -->
      <ui-bulk-actions-bar
        *ngIf="selectedQuotations.length > 0 && !(isCopilot$ | async)"
        [count]="selectedQuotations.length"
        (cleared)="clearSelection()"
      >
        <button class="ui-bulk-action" (click)="bulkDuplicate()" *appHasPermission="{ module: 'order', action: 'edit' }">
          <img src="assets/icones/copy.svg" alt="" />
          <span>{{ "quotations_and_orders.actions.duplicate" | translate }}</span>
        </button>
        <ng-container *appHasPermission="{ module: 'order', action: 'edit' }">
          <button class="ui-bulk-action" *ngIf="archived === 0" (click)="bulkArchive()">
            <img src="assets/icones/archive.svg" alt="" />
            <span>{{ "quotations_and_orders.actions.archive" | translate }}</span>
          </button>
          <button class="ui-bulk-action" *ngIf="archived === 1" (click)="bulkUnarchive()">
            <img src="assets/icones/unarchive.svg" alt="" />
            <span>{{ "quotations_and_orders.actions.unarchive" | translate }}</span>
          </button>
        </ng-container>
        <ng-container *appHasPermission="{ module: 'order', action: 'delete' }">
          <span
            [matTooltip]="hasUndeletableInSelection ? ('quotations_and_orders.bulk.undeletable_tooltip' | translate) : ''"
            matTooltipPosition="above"
          >
            <button class="ui-bulk-action ui-bulk-action--danger" [disabled]="deletableSelectionCount === 0" (click)="bulkDelete()">
              <ui-icon name="Trash2" size="medium"></ui-icon>
              <span>{{ "quotations_and_orders.actions.delete" | translate }}</span>
            </button>
          </span>
        </ng-container>
      </ui-bulk-actions-bar>
      <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────── -->

      <!-- Pagination lives inside the bordered container, below the rows -->
      <app-pagination
        *ngIf="(quotations$ | async)!.length > 0"
        class="orders-pagination"
        [pagination]="pagination$ | async"
        (toPageEvent)="toPage($event)"
      ></app-pagination>
    </div>
    <div *ngIf="filter && (displayQuotations$ | async)!.length === 0 && !(isAppLoading$ | async)" class="no_reseult">
      <ng-container *ngIf="filter?.filters!.length === 0 && !key && !status">
        <img class="no_intense" src="../../../../../assets/icones/no-quotations.svg" alt="" />
        <h3>{{ "quotations_and_orders.no_quotations" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="filter?.filters!.length > 0 || key || status">
        <img class="no_intense" src="../../../../../assets/icones/no-result-search.svg" alt="" />
        <h3>{{ "quotations_and_orders.no_quotations_data_search" | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="filter?.filters!.length === 0 && !key && !status">
        <button class="save_btn_pop_up blue_btn" data-testid="new-order-empty-state-btn" (click)="addQuotation()" *appHasPermission="{ module: 'order', action: 'create' }">
          <span>{{ "common.add" | translate | uppercase }}</span>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg" />
        </button>
      </ng-container>
    </div>
  </div>
</div>
